import { Modal } from '@/features/modals/components';
import { Banner } from '@trevor/ui-components';
import React, { FC } from 'react';
import styled from 'styled-components';
import { useRevokeInvitationMutation } from '@/features/dashboardShare/ShareDropdown/InviteTab/inviteApi';
import { useDashboardId, useDatasourceId } from '@/hooks';
import { useModalClose } from '@/features/modals/modalSlice';
import { userAction } from '@/util/helpers/ajax-helpers';

const DeleteInvitedUserModalContainer = styled(Modal)`
  padding: 48px;
  gap: var(--spacing-xl);
`;

type DeleteInvitedUserModalProps = {
  email: string;
};
export const DeleteInvitedUserModal: FC<DeleteInvitedUserModalProps> = ({
  email,
}) => {
  const datasourceId = useDatasourceId();
  const dashboardId = useDashboardId();
  const [revokeAccess, { isLoading }] = useRevokeInvitationMutation();

  const handleClose = useModalClose();

  const handleRevokeAccess = async () => {
    await revokeAccess({
      email,
      resourceName: 'TEMP NAME',
      resourceId: dashboardId,
      datasourceId,
      resourceType: 'DASHBOARD',
      accessType: 'READ',
    });
    userAction('embed-dashboards-sidebar-share-with-others-tab', {
      action: 'remove-user',
      value: email,
    });
    handleClose();
  };

  return (
    <DeleteInvitedUserModalContainer
      widthType="md"
      title="Do you really want to remove this user?"
      submitText="Remove user"
      onSubmit={handleRevokeAccess}
      submitLoading={isLoading}
    >
      <Banner severity="warning">
        This action is not reversible. User can be added again by sending the
        invitation.
      </Banner>
    </DeleteInvitedUserModalContainer>
  );
};
